import request from '@/utils/request'

export function tandeAuditItemsAll (params) {
  return request({
    url: '/amrep/tande/itemsAll',
    method: 'get',
    params
  })
}

export function tandeAuditDetails (data) {
  return request({
    url: '/amrep/tande/details/' + data.id,
    method: 'get'
  })
}

export function tandeAuditEmpTandEItems (params) {
  return request({
    url: '/amrep/tande/empTandEItems/' + params.id,
    method: 'get',
    params
  })
}

// 查询审核人员列表
export function itemsGroupEmp () {
  return request({
    url: '/amrep/tande/itemsGroupEmp',
    method: 'get'
  })
}

// 审核人员权限
export function groupUserItems (params) {
  return request({
    url: '/amrep/tande/groupUserItems',
    method: 'get',
    params
  })
}

export function changeAuditAuth (data) {
  return request({
    url: '/amrep/tande/changeAuditAuth/' + data.id,
    method: 'put',
    data
  })
}

export function deleteAuditAuth (data) {
  return request({
    url: '/amrep/tande/deleteAuditAuth/' + data.id,
    method: 'put',
    data
  })
}

export function createAuditAuth (data) {
  return request({
    url: '/amrep/tande/createAuditAuth/' + data.id,
    method: 'put',
    data
  })
}

export function throughA (data) {
  return request({
    url: '/amrep/tande/throughA/' + data.id,
    method: 'put',
    data
  })
}

export function throughB (data) {
  return request({
    url: '/amrep/tande/throughB/' + data.id,
    method: 'put',
    data
  })
}

export function refusedA (data) {
  return request({
    url: '/amrep/tande/refusedA/' + data.id,
    method: 'put',
    data
  })
}

export function refusedB (data) {
  return request({
    url: '/amrep/tande/refusedB/' + data.id,
    method: 'put',
    data
  })
}

export function contenItems () {
  return request({
    url: '/amrep/tande/contenItems',
    method: 'get'
  })
}

export function contenAdd (data) {
  return request({
    url: '/amrep/tande/contenAdd',
    method: 'post',
    data
  })
}

export function contentDel (data) {
  return request({
    url: '/amrep/tande/contentDel/' + data.id,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/tandeAudit.js